import { useSelector } from "react-redux";
import { Modal } from "risa-oasis-ui_v2";
import { ModalId } from "../../../enums/modalId";
import { RootState } from "../../../redux/store/store";
import ApiReponseViewer, {
  ApiReponseViewerProps,
} from "../../apiResponseViewer/apiReponseViewer";

interface ApiResponseViewerModalProps {
  onClose: () => void;
}

const ApiResponseViewerModal = (props: ApiResponseViewerModalProps) => {
  const handleClose = () => {
    props.onClose();
  };
  const { metaData } = useSelector((state: RootState) => state.modal);

  const {
    apiName,
    totalEntries,
    selectedApiRequest,
    requestData,
    responseData,
    statusCode,
  } = metaData as ApiReponseViewerProps;

  return (
    <Modal
      dialogId={ModalId.API_RESPONSE_VIEWER_MODAL}
      onSave={() => {}}
      title={"API Response Viewer"}
      saveButtonText={""}
      cancelText={""}
      hideFooter={true}
      onClose={handleClose}
      onCancel={handleClose}
      heightPercentage={90}
    >
      <div className="api-response-viewer--container h-full pb-2">
        <ApiReponseViewer
          apiName={apiName}
          totalEntries={totalEntries}
          selectedApiRequest={selectedApiRequest}
          requestData={requestData}
          responseData={responseData}
          statusCode={statusCode}
        />
      </div>
    </Modal>
  );
};

export default ApiResponseViewerModal;
